import React, { memo as Memo, useMemo } from 'react';
import { Form } from 'antd';

//* HOC's
import { withLanguageContext } from 'context';

//* Components
import Translate from 'components/common/Translate';

//* Helpers
import formValidation from '../../../helpers/_formValidation';

//* Style
import FormItemStyle from './style';

const FormItem = Memo(
	({
		label,
		name,
		type,
		validationType,
		className,
		required = true,
		min,
		max,
		message,
		autocomplete = 'new-password',
		extra,
		extraChild,
		rules = [],
		options = {},
		noStyle,
		hasFeedback = true,
		...props
	}) => {
		const newRules = useMemo(() => {
			let r = [...rules];

			if (type == 'email') {
				r.push({ transform: (value) => value.trim() });
			}

			const typeObj = type ? { type } : '';
			r[0] = { ...r?.[0], message: '', required, ...typeObj };

			const params = r[0];

			if (required || validationType) {
				r[1] = ({ getFieldValue }) => ({
					validator(_, value) {
						const validType = validationType || params.type || 'string';
						let validate;

						let settings;
						settings = min || typeof min === 'number' ? { ...settings, min: min } : settings;
						settings = max ? { ...settings, max: max } : settings;

						if (name === 'password_confirmation') {
							validate = formValidation(
								Translate,
								{ pass: getFieldValue('password'), c_pass: value },
								'c_password',
								value ? message : name + 'IsRequired'
							);
						} else {
							validate = formValidation(Translate, value, validType, name + 'IsRequired');
						}

						if (validate === true) {
							return Promise.resolve();
						}

						return Promise.reject(validate);
					},
				});
			}

			return r;
		}, [name, type, required, validationType, rules, min, max]);

		return (
			<FormItemStyle className={className || ''}>
				<Form.Item
					onChange={props.onChange}
					label={label && props.translate(label)}
					hasFeedback={hasFeedback}
					extra={extra && (extraChild || props.translate(extra))}
					name={name}
					rules={newRules}
					noStyle={noStyle}
					{...options}>
					{React.cloneElement(props.children, { autoComplete: autocomplete })}
				</Form.Item>
			</FormItemStyle>
		);
	}
);

export default withLanguageContext(FormItem, ['translate', 'selectedLang']);
